import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-wizard",
  templateUrl: "./wizard.component.html",
  styleUrls: ["./wizard.component.scss"],
  standalone: false,
})
export class WizardComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
